import { render, staticRenderFns } from "./PopupAddTipPercent.vue?vue&type=template&id=60d645ea&scoped=true&"
import script from "./PopupAddTipPercent.vue?vue&type=script&lang=js&"
export * from "./PopupAddTipPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d645ea",
  null
  
)

export default component.exports